module.exports = __webpack_public_path__ + "static/peixun-c1b64388a8d65d34305bfea687b9ba0f.png";